export const LOCATION_ORIGIN = window.location.origin;

export const GATEWAY_HARMADILLO = process.env.GATEWAY_HARMADILLO!;
export const GATEWAY_BADGER = process.env.GATEWAY_BADGER!;
export const GATEWAY_AUTH = process.env.GATEWAY_AUTH!;

export const DOCKER_COMPOSE = process.env.DOCKER_COMPOSE!;
export const AUTH_CLIENT_ID = process.env.AUTH_CLIENT_ID!;
export const NODE_ENV = process.env.NODE_ENV!;